import React from 'react'

const Table = ({
  columns = [],
  data = [],
  rowKey = (row) => row?.id || JSON.stringify(row),
  loading = false,
  error = '',
  emptyMessage = 'Nenhum registro encontrado.',
  className = '',
  tableClassName = '',
  rowClassName = '',
  onRowClick,
  highlightStriped = false,
}) => {
  const getRowClassName = (item, index) => {
    let baseClass = 'scout-table__row'
    if (rowClassName) {
      baseClass += ` ${rowClassName}`
    }
    if (highlightStriped && index % 2 === 1) {
      baseClass += ' scout-table__row--striped'
    }
    return baseClass
  }

  if (loading) {
    return (
      <div className={`scout-settings-card scout-settings-card--table ${className}`.trim()}>
        <div className={`scout-settings-table ${tableClassName}`.trim()}>
          <div className="scout-settings-table__row scout-settings-table__row--loading">Carregando...</div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className={`scout-settings-card scout-settings-card--table ${className}`.trim()}>
        <div className={`scout-settings-table ${tableClassName}`.trim()}>
          <div className="scout-settings-table__row scout-settings-table__row--error">{error}</div>
        </div>
      </div>
    )
  }

  if (!data || !data.length) {
    return (
      <div className={`scout-settings-card scout-settings-card--table ${className}`.trim()}>
        <div className={`scout-settings-table ${tableClassName}`.trim()}>
          <div className="scout-settings-table__row scout-settings-table__row--empty">{emptyMessage}</div>
        </div>
      </div>
    )
  }

  return (
    <div className={`scout-settings-card scout-settings-card--table ${className}`.trim()}>
      <table className={`scout-table ${tableClassName}`.trim()}>
        <thead className="scout-table__head">
          <tr>
            {columns.map((column) => (
              <th key={column.id || column.label} style={{ width: column.width || undefined, textAlign: column.align || 'left' }}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={rowKey(item, index)}
              className={getRowClassName(item, index)}
              onClick={() => onRowClick?.(item)}
              style={{ cursor: onRowClick ? 'pointer' : 'default' }}
            >
              {columns.map((column) => (
                <td key={`${rowKey(item, index)}-${column.id || column.label}`} style={{ textAlign: column.align || 'left' }}>
                  {typeof column.render === 'function' ? column.render(item) : item[column.id]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
